import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  connect() {
    this.focusInput()
  }

  focusInput() {
    if (!this.inputTarget.value) return

    this.inputTarget.focus()

    this.inputTarget.setSelectionRange(
      this.inputTarget.value.length,
      this.inputTarget.value.length
    )
  }
}
